import "./PreferencesPage.css";
//import '@scuf/datatable/honeywell-dark/theme.css'
import { Button, Grid, Input, Modal } from "@scuf/common";
import { DataTable } from "@scuf/datatable";
import "@scuf/datatable/honeywell-compact-dark/theme.css";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  getParametrosModelos,
  setParametroModelo,
} from "../../services/services";

export default function PreferencesPage() {
  //const inputRef = useRef();

  // data por default de la tabla de granulometria
  /*
  const mockGranulometricos = [
    {
      param: "Malla #48 (abertura 300 µm)",
      design: 100.0,
      min: 100.0,
      max: 99.4,
    },
    {
      param: "Malla #65 (abertura 212 µm)",
      design: 100.0,
      min: 100.0,
      max: 98.5,
    },
    {
      param: "Malla #100 (abertura 150 µm)",
      design: 100.0,
      min: 100.0,
      max: 95.7,
    },
    {
      param: "Malla #150 (abertura 106 µm)",
      design: 100.0,
      min: 99.4,
      max: 89.2,
    },
    {
      param: "Malla #200 (abertura 75 µm)",
      design: 97.0,
      min: 96.4,
      max: 77.6,
    },
    {
      param: "Malla #270 (abertura 53 µm)",
      design: 91.0,
      min: 88.4,
      max: 42.7,
    },
    {
      param: "Malla #325 (abertura 45 µm)",
      design: 85.0,
      min: 84.9,
      max: 21.3,
    },
    { param: "Malla #-325 (menor a 45 µm)", design: 0.0, min: 0.0, max: 0.0 },
  ];*/

  // useState para lo parametros de ajuste
  const [adjustParams, setAdjustParams] = useState({
    data: [],
    isLoading: false,
  });

  // useState para lo parametros de ajuste R
  const [adjustParamsR, setAdjustParamsR] = useState({
    data: [],
    isLoading: false,
  });

  // useState para lo parametros de granulometria
  const [adjustParamsGranu, setAdjustParamsGranu] = useState({
    data: [],
    isLoading: false,
  });

  /*
  const [updated, setUpdated] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [updatedProperty, setUpdatedProperty] = useState({
    idParametro: null,
    title: null,
    value: null,
  });*/

  const [valorProvi, setValorProvi] = useState(null);
  const [loading, setLoading] = useState(false);

  /**
   * Traemos la data inicial de esta pagina
   */
  async function fetchData() {
    setLoading(true);
    const { data } = await getParametrosModelos();
    // Campos de parametros de ajuste OrdenTipo(1) = Parametro Ajuste
    const arrAdjustParams = data.filter((element) => element.OrdenTipo === 1);
    // Campos de parametros de ajuste R OrdenTipo(2) = Parametrización R. Cpy/Bo=A*Py+B
    const arrAdjustParamsR = data.filter((element) => element.OrdenTipo === 2);
    // Campos de parametros para grafico de granulometria
    const arrGranulometria = data.filter((element) => element.OrdenTipo === 3);

    // Preguntamos si tiene datos
    if (arrAdjustParams.length > 0) {
      setAdjustParams({ data: arrAdjustParams, isLoading: false });
    }

    // Preguntamos si tiene datos
    if (arrAdjustParamsR.length > 0) {
      setAdjustParamsR({ data: arrAdjustParamsR, isLoading: false });
    }

    // Preguntamos si tiene datos
    if (arrGranulometria.length > 0) {
      setAdjustParamsGranu({ data: arrGranulometria, isLoading: false });
    }
    document.dispatchEvent(new Event("click"));
    setLoading(false);
  }

  /*
  function focusInput() {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }*/

  /*
  function returnModal(data) {
    console.log(data.data);
    if (data.data) {
      setUpdatedProperty({
        idParametro: data.data.idParametro,
        title: data.data.Parametro,
        value: data.data.Valor,
      });
      setOpenModal(true);
    } else {
      setOpenModal(false);
    }
  }*/

  /*
  function editDataParamsR(newData, cellData) {
    const copyArr = [...adjustParamsR.data];

    const findCopy = copyArr.filter(
      (element) => element.idParametro === cellData.rowData.idParametro
    );
    if (cellData.field === "Valor") {
      copyArr[findCopy[0].Orden - 1].Valor = newData;
    } else if (cellData.field === "Valor2") {
      copyArr[findCopy[0].Orden - 1].Valor2 = newData;
    }

    setAdjustParamsR({ data: copyArr });

    if (findCopy[0] && cellData.value) {
      // Realizamos update
      if (cellData.field === "Valor") {
        // Condicion para cuando es el minimo

        setTimeout(() => {
          setParametroModelo({
            idParametro: findCopy[0].idParametro,
            valor: findCopy[0].Valor,
          })
            .then(() => {
              toast.success("Parametro actualizado!", {
                toastId: "preference-succes",
              });
              fetchData();
            })

            .catch(() => {
              toast.error("Error inesperado!", { toastId: "preference-error" });
            });
        }, 3000);
      } else if (cellData.field === "Valor2") {
        //Condicion para cuando es el maximo

        setTimeout(() => {
          setParametroModelo({
            idParametro: findCopy[0].idParametro,
            valor2: findCopy[0].Valor2,
          })
            .then(() => {
              toast.success("Parametro actualizado!", {
                toastId: "preference-succes",
              });
              fetchData();
            })
            .catch(() => {
              toast.error("Error inesperado!", { toastId: "preference-error" });
            });
        }, 3000);
      }
    }
  }

  function editData(newData, cellData) {
    const copyArr = [...adjustParamsGranu.data];

    const findCopy = copyArr.filter(
      (element) => element.idParametro === cellData.rowData.idParametro
    );
    if (cellData.field === "Valor") {
      copyArr[findCopy[0].Orden - 1].Valor = newData;
    } else if (cellData.field === "Valor2") {
      copyArr[findCopy[0].Orden - 1].Valor2 = newData;
    }
    setAdjustParamsGranu({ data: copyArr });

    if (findCopy[0] && cellData.value) {
      // Realizamos update
      if (cellData.field === "Valor") {
        // Condicion para cuando es el minimo

        setTimeout(() => {
          setParametroModelo({
            idParametro: findCopy[0].idParametro,
            valor: findCopy[0].Valor,
          })
            .then(() => {
              toast.success("Parametro actualizado!", {
                toastId: "preference-succes",
              });
              fetchData();
            })
            .catch(() => {
              toast.error("Error inesperado!", { toastId: "preference-error" });
            });
        }, 3000);
      } else if (cellData.field === "Valor2") {
        //Condicion para cuando es el maximo

        setTimeout(() => {
          setParametroModelo({
            idParametro: findCopy[0].idParametro,
            valor2: findCopy[0].Valor2,
          })
            .then(() => {
              setUpdated(true);
              toast.success("Parametro actualizado!", {
                toastId: "preference-succes",
              });
              fetchData();
            })
            .catch(() => {
              toast.error("Error inesperado!", { toastId: "preference-error" });
            });
        }, 3000);
      }
    }
  }*/

  /*
  function saveValue() {
    setParametroModelo({
      idParametro: updatedProperty.idParametro,
      valor: updatedProperty.value,
      valor2: null,
    })
      .then(() => {
        setUpdated(true);
        toast.success("Parametro actualizado!", {
          toastId: "preference-succes",
        });
      })
      .catch(() => {
        toast.error("Error inesperado!", { toastId: "preference-error" });
        setUpdated(true);
      })
      .finally(() => {
        setUpdated(false);
        setOpenModal(false);
      });
  }*/

  function saveData2(event, cellData) {
    event.preventDefault();
    setLoading(true);

    if (cellData.field === "Valor") {
      // Condicion para cuando es el minimo

      setParametroModelo({
        idParametro: cellData.rowData.idParametro,
        valor: valorProvi,
      })
        .then(() => {
          toast.success("Parametro actualizado!");
          fetchData();
        })

        .catch(() => {
          toast.error("Error inesperado!", { toastId: "preference-error" });
        });
    } else if (cellData.field === "Valor2") {
      //Condicion para cuando es el maximo

      setParametroModelo({
        idParametro: cellData.rowData.idParametro,
        valor2: valorProvi,
      })
        .then(() => {
          toast.success("Parametro actualizado!");
          fetchData();
        })
        .catch(() => {
          toast.error("Error inesperado!", { toastId: "preference-error" });
        });
    }
    setLoading(false);
  }

  function editDataNew(cellData) {
    const placeholder =
      cellData.field === "Valor"
        ? cellData.rowData.Valor
        : cellData.rowData.Valor2;

    return (
      <>
        <div className="container-input-button">
          <Input
            id="input-edit-data"
            placeholder={placeholder}
            value={valorProvi}
            onChange={(value) => {
              setValorProvi(value);
            }}
          />
          <Button
            id="button-edit-data"
            type="primary"
            content=""
            actionType="submit"
            icon="refresh"
            iconPosition="left"
            onClick={(event) => {
              saveData2(event, cellData);
            }}
            loading={loading}
          />
        </div>
      </>
    );
  }

  // Efecto para hacer la consulta
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column
            width={8}
            lWidth={9}
            mWidth={12}
            sWidth={12}
            xsWidth={12}
          >
            <DataTable
              data={adjustParams.data}
              resizableColumns={true}
              onCellClick={(data) => {
                setValorProvi(data.value);
              }}
            >
              <DataTable.Column
                initialWidth={500}
                field="Parametro"
                header="Parametro"
                placeholder="N/A"
              />
              <DataTable.Column
                initialWidth={150}
                field="Valor"
                header="Valor"
                placeholder="N/A"
                align="center"
                customEditRenderer={(cellData) => editDataNew(cellData)}
                editable={true}
              />
              <DataTable.Column
                initialWidth={150}
                field="Unidad"
                header="Unidad"
                placeholder="N/A"
                align="center"
              />
            </DataTable>
          </Grid.Column>

          <Grid.Column
            width={8}
            lWidth={9}
            mWidth={12}
            sWidth={12}
            xsWidth={12}
          >
            <DataTable
              data={adjustParamsR.data}
              onCellClick={(data) => {
                setValorProvi(data.value);
              }}
            >
              <DataTable.HeaderBar>
                <DataTable.HeaderBar.Item
                  content={
                    <p>
                      Py: contenido de Pirita en base 1; En: contenido de
                      Enargita en base 1; Ten: contenido de Tenantita en base 1;
                      En+Ten=Suma de contenido Enargita y Tenantita en Base 1
                    </p>
                  }
                  className="header-description"
                  iconSize="small"
                  icon="badge-info"
                />
              </DataTable.HeaderBar>
              <DataTable.Column
                initialWidth={500}
                field="Parametro"
                header="Parametrización: R. Cy/Bo=%Py*A+B"
                placeholder="N/A"
              />
              <DataTable.Column
                initialWidth={150}
                field="Valor"
                header="A"
                placeholder="N/A"
                align="center"
                editable={true}
                customEditRenderer={(cellData) => editDataNew(cellData)}
              />
              <DataTable.Column
                initialWidth={150}
                field="Valor2"
                header="B"
                placeholder="N/A"
                align="center"
                editable={true}
                customEditRenderer={(cellData) => editDataNew(cellData)}
              />
            </DataTable>
          </Grid.Column>

          <Grid.Column
            width={8}
            lWidth={9}
            mWidth={10}
            sWidth={11}
            xsWidth={12}
          >
            <DataTable
              data={adjustParamsGranu.data}
              reorderableColumns={false}
              resizableColumns={false}
              virtualRowHeight={32}
              onCellClick={(data) => {
                setValorProvi(data.value);
              }}
            >
              <DataTable.Column
                field="Parametro"
                header="Parametrización Granulométricos (pasantes acumulados)"
                initialWidth="8rem"
              />

              <DataTable.Column
                field="Unidad"
                header="Diseño, %"
                placeholder="N/A"
                align="center"
                initialWidth="6rem"
              />

              <DataTable.Column
                field="Valor"
                header="Curva mínima de referencia"
                placeholder="N/A"
                align="center"
                initialWidth="6rem"
                editable={true}
                customEditRenderer={(cellData) => editDataNew(cellData)}
              />

              <DataTable.Column
                field="Valor2"
                header="Curva máxima de referencia"
                align="center"
                initialWidth="7rem"
                editable={true}
                customEditRenderer={(cellData) => editDataNew(cellData)}
              />
            </DataTable>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
